<div class="grid xl:grid-cols-1 grid-cols-1">
  <div class="">
    <div class="bgcolor px-1 w-full">
      <div class="header-main flex justify-between items-center">
        <div class="header-primary flex justify-items-left items-center gap-2">
          <img
            src="assets/images/Vinmarts3DLogo.png"
            class="header-logo-desktop hide-xs h-16 w-52 cursor-pointer object-contain"
            routerLink="/"
            alt="https://vinmarts.in/"
          />
          <img
            src="assets/images/vinmart.png"
            class="header-logo-mobile lg:hidden sm:hidden xl:hidden md:hidden h-16 object-contain w-16 cursor-pointer"
            routerLink="/"
            alt="https://vinmarts.in/"
          />
          <div class="header-desktop-search relative hide-xs lg:ml-[210px]">
            <input
              type="text"
              [(ngModel)]="searchTerm"
              (input)="onSearchInput($event)"
              (keyup.enter)="onSearch()"
              (focus)="showSuggestions = true"
              (blur)="hideSuggestions()"
              class="rounded-3xl py-3 px-3 outline-none text-xs w-[400px] pr-10 hidden lg:block md:block"
              placeholder="Search for Products, Stores, Brands and more..."
            />

            <!-- search icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-5 h-5 text-green-900 absolute right-3 top-1/2 transform -translate-y-1/2 hidden lg:block md:block"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
              />
            </svg>

            <!-- 🔹 Suggestions dropdown -->
            <!-- Suggestions dropdown -->
            <!-- 🔹 Suggestions dropdown -->
            <div
              *ngIf="
                showSuggestions && (searchHistory.length || suggestions.length)
              "
              class="absolute top-[48px] left-0 w-full bg-white rounded-md shadow-lg border border-gray-200 z-50 max-h-[400px] overflow-y-auto"
            >
              <ul class="divide-y divide-gray-100">
                <!-- 🕘 Search History Section -->
                <ng-container *ngIf="searchHistory.length">
                  <li
                    class="px-3 py-2 text-xs text-gray-500 bg-gray-50 font-semibold"
                  >
                    Recent Searches
                  </li>
                  <li
                    *ngFor="let item of searchHistory"
                    (mousedown)="useHistorySearch(item)"
                    class="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4 h-4 text-gray-500"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 6v6l3 3m6 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                    <span class="text-sm text-gray-700">{{ item.term }}</span>
                  </li>
                </ng-container>

                <!-- 🔍 Suggestions Section -->
                <ng-container *ngIf="suggestions.length">
                  <li
                    class="px-3 py-2 text-xs text-gray-500 bg-gray-50 font-semibold"
                  >
                    Suggestions
                  </li>
                  <li
                    *ngFor="let suggestion of suggestions"
                    (mousedown)="selectSuggestion(suggestion)"
                    class="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3"
                  >
                    <img
                      *ngIf="suggestion.image"
                      [src]="imageUrl + suggestion.image"
                      alt="{{ suggestion.keyword }}"
                      class="w-8 h-8 object-cover rounded"
                    />
                    <div class="flex flex-col">
                      <span class="text-sm text-gray-800">{{
                        suggestion.keyword
                      }}</span>
                      <span class="text-xs text-[#7B68EE] font-medium"
                        >in {{ suggestion.category }}</span
                      >
                    </div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>

          <div
            class="header-mobile-search hide-md flex justify-items-center items-center gap-2"
          >
            <!-- 🔹 MOBILE SEARCH INPUT -->
            <div class="relative block lg:hidden w-[190px]">
              <input
                type="text"
                [(ngModel)]="searchTerm"
                (input)="onSearchInput($event)"
                (keyup.enter)="onSearch()"
                (focus)="showSuggestions = true"
                (blur)="hideSuggestions()"
                class="rounded-3xl py-2 px-3 outline-none text-xs w-full pr-8"
                placeholder="Search for Products..."
              />

              <!-- search icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 h-5 text-green-900 absolute right-3 top-1/2 transform -translate-y-1/2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>

              <!-- 🔹 MOBILE Suggestions Dropdown -->
              <div
                *ngIf="
                  showSuggestions &&
                  (searchHistory.length || suggestions.length)
                "
                class="absolute top-[45px] left-0 w-full bg-white rounded-md shadow-lg border border-gray-200 z-50 max-h-[300px] overflow-y-auto block lg:hidden"
              >
                <ul class="divide-y divide-gray-100">
                  <!-- 🔍 Suggestions -->
                  <ng-container *ngIf="suggestions.length">
                    <li
                      class="px-3 py-2 text-xs text-gray-500 bg-gray-50 font-semibold"
                    >
                      Suggestions
                    </li>
                    <li
                      *ngFor="let suggestion of suggestions"
                      (mousedown)="selectSuggestion(suggestion)"
                      class="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3"
                    >
                      <img
                        *ngIf="suggestion.image"
                        [src]="imageUrl + suggestion.image"
                        alt="{{ suggestion.keyword }}"
                        class="w-8 h-8 object-cover rounded"
                      />
                      <div class="flex flex-col">
                        <span class="text-sm text-gray-800">{{
                          suggestion.keyword
                        }}</span>
                        <span class="text-xs text-[#7B68EE] font-medium">
                          in {{ suggestion.category }}
                        </span>
                      </div>
                    </li>
                  </ng-container>

                  <!-- 🕘 Recent Searches (optional on mobile) -->
                  <ng-container
                    *ngIf="!suggestions.length && searchHistory.length"
                  >
                    <li
                      class="px-3 py-2 text-xs text-gray-500 bg-gray-50 font-semibold"
                    >
                      Recent Searches
                    </li>
                    <li
                      *ngFor="let item of searchHistory"
                      (mousedown)="useHistorySearch(item)"
                      class="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-4 h-4 text-gray-500"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 6v6l3 3m6 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        />
                      </svg>
                      <span class="text-sm text-gray-700">{{ item.term }}</span>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>

          <div class="header-cart flex" (click)="myCartPage()">
            <button
              class="py-3 px-1 relative border-2 border-transparent text-white rounded-full focus:outline-none transition duration-150 ease-in-out"
              aria-label="Cart"
            >
              <div class="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  class="w-8 h-8 text-white rounded-full lg:mr-4 lg:ml-3 ring-2 ring-white p-1 relative"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                  />
                  <!-- <text x="13" y="8" class="text-xs text-yellow-300">2</text> Adjust position as needed -->
                </svg>
              </div>
              <span
                class="absolute inset-0 object-right-top mr-7"
                *ngIf="userDetails !== null"
              >
                <div
                  class="inline-flex items-center px-1.5 py-0.3 mb-6 border-2 border-white rounded-full text-xs font-semibold leading-2 bg-red-700 text-white"
                  *ngIf="totalProducts >= 1"
                >
                  {{ totalProducts }}
                </div>
              </span>
            </button>
          </div>

          <div
            #profileDropdown
            class="header-profile relative inline-block overflow-visible z-[9999]"
            (mouseenter)="openProfileMenu()"
          >
            <!-- Login Icon -->
            <div
              *ngIf="!userDetails"
              class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border-2 border-white"
            >
              <svg
                class="h-6 w-6 text-white"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="5" y="11" width="14" height="10" rx="2" />
                <circle cx="12" cy="16" r="1" />
                <path d="M8 11v-4a4 4 0 0 1 8 0v4" />
              </svg>
            </div>

            <!-- User Avatar -->
            <div *ngIf="userDetails">
              <span
                class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border-2 border-white text-xl font-bold text-white"
              >
                {{ userDetails?.name[0] }}
              </span>
            </div>

            <!-- Dropdown -->
            <div
              *ngIf="isProfileMenuOpen"
              class="absolute right-0 top-full mt-3 w-56 rounded-lg bg-black shadow-2xl z-[9999]"
            >
              <div class="py-3">
                <!-- Guest -->
                <ng-container *ngIf="!userDetails">
                  <button
                    (click)="onLogin()"
                    class="mx-auto block w-28 rounded-lg bg-[#7B68EE] px-4 py-2 font-semibold text-white transition hover:bg-[#6756df]"
                  >
                    Login
                  </button>

                  <div
                    class="mt-3 border-b border-gray-600 pb-3 text-center text-sm text-white"
                  >
                    New user?
                    <span
                      routerLink="/Signin"
                      class="ml-1 cursor-pointer font-bold underline hover:text-purple-300"
                    >
                      Register
                    </span>
                  </div>
                </ng-container>

                <!-- Logged In -->
                <ng-container *ngIf="userDetails">
                  <a
                    routerLink="/profile-details"
                    class="block px-5 py-3 text-sm text-white hover:bg-gray-800"
                  >
                    Profile
                  </a>

                  <a
                    (click)="orderList()"
                    class="block cursor-pointer px-5 py-3 text-sm text-white hover:bg-gray-800"
                  >
                    Orders
                  </a>

                  <a
                    (click)="wishList()"
                    class="block cursor-pointer px-5 py-3 text-sm text-white hover:bg-gray-800"
                  >
                    Wishlist
                  </a>

                  <a
                    (click)="notification()"
                    class="block cursor-pointer px-5 py-3 text-sm text-white hover:bg-gray-800"
                  >
                    Notification
                  </a>

                  <div class="mt-2 border-t border-gray-600"></div>

                  <a
                    (click)="logOut()"
                    class="block cursor-pointer px-5 py-3 text-sm font-semibold text-white hover:bg-red-600"
                  >
                    Logout
                  </a>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="header-seller hide-xs">
            <div
              class="flex flex-col items-center justify-center gap-5 ml-10 md:flex-row"
            >
              <a
                class="inline-block w-auto text-lg font-semibold text-center min-w-[200px] px-6 py-1 text-[#5B21B6] transition-all rounded-md shadow-xl sm:w-auto bg-white hover:bg-gradient-to-b dark:shadow-blue-900 hover:shadow-2xl hover:shadow-blue-400 hover:-tranneutral-y-px"
                href="https://seller.vinmarts.in/register"
                target="_blank"
                >Become a Seller
              </a>
            </div>
          </div>
          <div class="header-language">
            <div class="translate-container ml-4 relative">
              <button
                class="translate-btn"
                (click)="toggleDropdown()"
                translate="no"
              >
                🌐
                <span>{{ selectedLanguageCode.toUpperCase() }}</span>
              </button>

              <div
                class="translate-dropdown absolute left-0 top-full mt-2"
                *ngIf="dropdownOpen"
                translate="no"
              >
                <input
                  type="text"
                  placeholder="Search language..."
                  [(ngModel)]="searchText"
                  class="search-input"
                />
                <ul>
                  <li
                    *ngFor="let lang of filteredLanguages()"
                    (click)="changeLanguage(lang.code)"
                  >
                    {{ lang.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="header-rewards relative inline-block group">
            <!-- Button -->
            <button
              class="flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-2 py-2 text-sm font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-gray-50"
            >
              <i class="fa-solid fa-gem text-violet-500"></i>

              <span class="header-reward-label">Rewards</span>

              <strong class="header-reward-balance text-violet-500">
                ₹ {{ balance | number: "1.2-2" }}
              </strong>

              <i class="fa-solid fa-chevron-down text-xs text-gray-400"></i>
            </button>

            <!-- Dropdown -->
            <div
              class="absolute p-2 right-0 top-full z-50 hidden w-30 rounded-xl border border-gray-200 bg-white shadow-xl group-hover:block"
            >
              <small class="text-gray-500"> Rewards Balance </small>

              <h4 class="mt-1 mb-1 text-2xl font-bold text-gray-800">
                ₹ {{ balance | number: "1.2-2" }}
              </h4>

              <!-- <hr class="mb-4 border-gray-200"> -->

              <button
                routerLink="/wallet"
                class="w-full rounded-lg bg-violet-600 px-4 py-2 font-medium text-white transition hover:bg-violet-700"
              >
                View Rewards
              </button>
            </div>
          </div>

          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            (click)="toggle()"
            stroke="currentColor"
            class="w-8 h-8 lg:hidden text-white"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
            />
          </svg> -->
          <!-- Menu / Close Icon -->
          <!-- <svg
  *ngIf="!isCollapsed"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  (click)="toggle()"
  stroke="currentColor"
  class="w-8 h-8 lg:hidden text-white cursor-pointer"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
  />
</svg>


<svg
  *ngIf="isCollapsed"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  (click)="toggle()"
  stroke="currentColor"
  class="w-8 h-8 lg:hidden text-white cursor-pointer"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M6 18L18 6M6 6l12 12"
  />
</svg> -->
        </div>
      </div>
    </div>
  </div>

  <!-- <div
    [ngClass]="{
      'translate-x-0': isCollapsed,
      '-translate-x-full': !isCollapsed
    }"
    class="bgcolor fixed z-30 top-0 left-0 w-64 h-full shadow-lg transform transition-transform duration-300 ease-in-out overflow-y-auto"
  >
    <div class="p-4">
      <h2 class="text-xl font-semibold text-white">All Products List</h2>
      <ul class="flex flex-col gap-2 max-w-[280px] mx-auto mt-2">
        <li *ngFor="let catItem of categoriesProduct">
          <details class="group">
            <summary
              class="flex items-center justify-between gap-2 p-2 font-medium marker:content-none hover:cursor-pointer"
            >
              <span class="flex gap-2">
                <img
                  class="w-6 h-6 rounded-lg"
                  [src]="imageUrl + catItem.imageUrl"
                  alt=""
                />
                <span
                  class="text-white close-button"
                  (click)="categroies(catItem?._id)"
                  (mouseenter)="toggleSubCategory(catItem._id)"
                  (mouseleave)="toggleSubCategory(null)"
                  >{{ catItem?.name }}</span
                >
              </span>
            </summary>

           
            <ul
              *ngIf="expandedSubCategory === catItem._id"
              class="px-4 pb-4 flex flex-col gap-4 pl-2 mt-4"
            >
              <li
                *ngFor="let subCat of catItem?.subCategories"
                class="flex flex-col gap-2"
              >
                <div
                  class="flex gap-2 hover:text-purple-400 cursor-pointer"
                  (click)="toggleSubCategory(subCat.id)"
                >
                  <img
                    class="w-6 h-6 rounded-lg"
                    [src]="imageUrl + subCat.imageUrl"
                    alt=""
                  />
                  <a class="text-white" (click)="categroiesSub(subCat?._id)">
                    {{ subCat?.name }}
                  </a>
                </div>

                
                <ul
                  *ngIf="expandedSubCategory === subCat.id"
                  class="px-4 pb-4 flex flex-col gap-4 pl-2 mt-2"
                >
                  <li
                    *ngFor="let subSubCate of subCat?.subCategories"
                    class="flex gap-2 hover:text-purple-400"
                  >
                    <img
                      class="w-6 h-6 rounded-lg"
                      [src]="imageUrl + subSubCate.imageUrl"
                      alt=""
                    />
                    <a
                      class="subcate text-white"
                      (click)="categroiesSubSub(subSubCate._id)"
                    >
                      {{ subSubCate?.name }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </details>
        </li>
      </ul>
    </div>
  </div> -->

  <div
    *ngIf="Router.url === '/' || Router.url === '/home'"
    class="header-home-categories lg:hidden"
  >
    <div class="py-2 overflow-x-auto scrollbar-hide px-4">
      <div class="flex items-start gap-4 min-w-max pb-2">
        <div
          *ngFor="let catItem of categoriesProduct"
          class="flex-shrink-0 flex flex-col items-center w-20"
          (mouseenter)="toggleSubCategory(catItem._id)"
          (mouseleave)="toggleSubCategory(null)"
        >
          <button
            (click)="categroies(catItem?._id)"
            class="flex items-center justify-center w-14 h-14 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-purple-700 shadow-sm transition-all duration-200"
          >
            <img
              class="w-14 h-14 rounded-full object-contain border-2 border-white/30"
              [src]="imageUrl + catItem.imageUrl"
              [alt]="catItem.name"
              (error)="catItem.imageUrl = 'assets/fallback-category.png'"
            />
          </button>
          <span
            class="text-black text-xs font-medium text-center mt-2 leading-tight line-clamp-2"
            style="word-break: break-word; hyphens: auto"
          >
            {{ catItem?.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
